var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.getMusterOption()
    ? _c(
        "div",
        [
          _vm.sampleConfigValid()
            ? _c(
                "SaveProductConfigurationModal",
                {
                  attrs: {
                    buttonLabel: _vm._f("translate")(
                      "txtSaveOrderAndProceedToBasket"
                    ),
                    name: "save-sample-productConf",
                  },
                  on: {
                    saveConfiguration: function ($event) {
                      return _vm.saveSampleAndAddToBasket($event)
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn--link w-100 text-shade-darker font-weight-light text-decoration-none flex-column",
                      attrs: {
                        disabled:
                          !_vm.configuratorService.isConfigurationComplete(),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$modal.show("save-sample-productConf")
                        },
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm._f("translate")("txtOrderSamples"))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-xsmall" }, [
                        _vm._v(
                          _vm._s(_vm._f("translate")("txtVersandMuster")) +
                            " " +
                            _vm._s(_vm.musterVersandtermin)
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm.samplesAllowed
            ? _c(
                "div",
                { staticClass: "d-flex p-2 w-100 text-small line-height-12" },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "mr-2 svg-icon flex-child-fix position-relative t-1px",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 36 36",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "18", cy: "18", r: "18", fill: "#707171" },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                          fill: "#fff",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm._f("translate")("txtSampleRestrictionInfo")) +
                      "\n  "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }